import { memo, useState } from 'react'
import ScreenShell from './ScreenShell'
import { Button, Input } from './figma'
import { useToast } from './Toast'
import { useIsMounted } from '../lib/useIsMounted'
import { getWebApp } from '../lib/telegram'

function ButtonSpinner() {
  return (
    <svg
      className="h-5 w-5 animate-spin text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}

function PromoScreen({ onSuccess }) {
  const [code, setCode] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const { showToast } = useToast()
  const isMountedRef = useIsMounted()

  const handleSubmit = async (event) => {
    event.preventDefault()

    const trimmedCode = code.trim()
    if (!trimmedCode || loading) {
      return
    }

    setError(null)
    setLoading(true)

    try {
      const tg = getWebApp()
      const response = await fetch('/api/webapp-promo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          initData: tg.initData || '',
          code: trimmedCode,
        }),
      })

      const result = await response.json().catch(() => ({}))

      if (!response.ok || !result.ok) {
        if (isMountedRef.current) {
          setError(String(result.error || 'Не удалось активировать промокод'))
        }
        return
      }

      showToast({
        text: `Промокод активирован: +${result.bonus} ₽`,
        type: 'success',
      })
      onSuccess?.()
    } catch (submitError) {
      console.error('[PromoScreen] activate failed', submitError)
      if (isMountedRef.current) {
        setError('Не удалось активировать промокод')
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false)
      }
    }
  }

  return (
    <ScreenShell title="Промокод">
      <form
        className="flex min-h-0 w-full flex-1 flex-col overflow-hidden"
        onSubmit={handleSubmit}
      >
        <div className="flow-screen-scroll relative min-h-0 w-full flex-1 space-y-4 overflow-y-auto pb-4">
          <p className="text-sm leading-relaxed text-[var(--color-text-secondary)]">
            Активируйте промокод и получите бонус на баланс. Один промокод в день.
          </p>

          <Input
            type="text"
            value={code}
            onChange={(event) => {
              setCode(event.target.value.toUpperCase())
              if (error) {
                setError(null)
              }
            }}
            placeholder="Введите промокод"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
          />

          {error ? (
            <p className="text-sm text-red-500">{error}</p>
          ) : null}
        </div>

        <div className="flow-screen-actions">
          <Button type="submit" variant="main" disabled={loading || !code.trim()} className="gap-2">
            {loading ? (
              <>
                <ButtonSpinner />
                <span>Активация...</span>
              </>
            ) : (
              'Активировать'
            )}
          </Button>
        </div>
      </form>
    </ScreenShell>
  )
}

export default memo(PromoScreen)
